<script>
/**
 * The purpose of this component is just to add styles to whatever is passed to this component, without creating any
 * additional wrapper elements
 */
export default {
  name: 'Styled',
  props: {
    className: {
      type: String,
      required: true
    }
  },
  render (createElement) {
    // Get the default slot's children
    const defaultSlot = this.$slots.default

    // Check if there is at least one child in the default slot
    if (defaultSlot && defaultSlot.length === 1) {
      let props = {}

      const { staticClass, class: className, ...restProps } = defaultSlot[0].data ?? {}

      let resultingClassName = this.className
      if (staticClass) {
        resultingClassName = `${staticClass} ${this.className}`
      } else if (className) {
        if (typeof className === 'string') {
          resultingClassName = `${className} ${this.className}`
        } else if (Array.isArray(className)) {
          resultingClassName = [...className, this.className]
        } else if (typeof className === 'object' && className !== null) {
          resultingClassName = {
            ...className,
            [this.className]: true
          }
        }
      }

      props = {
        class: resultingClassName,
        ...restProps
      }

      return createElement(
        defaultSlot[0].tag,
        props,
        defaultSlot[0].children
      )
    } else {
      // If there is no child or more than one child, just return the original slot content
      return createElement('div', this.$slots.default)
    }
  }
}
</script>
